import * as React from "react";
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  GridColDef,
  GridRenderCellParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import {
  useGetUsedProductsMutation,
  useRemoveAggregateProductAsyncMutation,
  useSyncUsedProductMutation,
} from "../../redux/reducer/features/Product/productSlice";
import { AppFilter } from "../../models/app/AppModels";
import { AppState } from "../../redux/reducer/rootReducer";
import { useSelector } from "react-redux";
import ServerAppGrid from "../../compenents/app/ServerAppGrid";
import { DmsWhlegoodRequestDto } from "../../models/features/ShoppingPortal/DmsPart";
import ShopifyProductDetails from "../../compenents/Used Products/ShopifyProductDetails";
import CloseIcon from "@mui/icons-material/Close";
import { AppGridId } from "../../models/app/AppGridModels";
import { GetAppGridColumns } from "../../services/utilities/utility";
import { useAddPriceRuleMutation } from "../../redux/reducer/features/Integration/DmsSetupSlice";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import WarningIcon from "@mui/icons-material/Warning";

const UsedProducts: React.FunctionComponent = () => {
  const gridSetting = useSelector((state: AppState) =>
    state?.AppGridReducer?.setting.find(
      (x) => x.gridId === AppGridId.Used_Products
    )
  );
  const { dmsSetup } = useSelector((state: AppState) => state.authReducer);
  const Locations = useSelector(
    (state: AppState) => state.authReducer?.dmsSetup?.dmsLocations
  );

  const [paging, setPaging] = React.useState<AppFilter>({
    pageIndex: 0,
    pageSize: 10,
    totalRecords: 0,
    items: [],
    quickFilterValues: [],
    virtualShowroomProducts: true,
  });

  const [products, setProducts] = React.useState<any[]>([]);
  const [productsCount, setProductsCount] = React.useState<number>(0);
  const [newPrice, setNewPrice] = React.useState("");
  const [selectedProduct, setSelectedProduct] = React.useState({
    shopifyProductId: "",
    productAggId: "",
    price: 0,
  });
  const [selectedRowData, setSelectedRowData] = React.useState<any>();
  const [openDescription, setOpenDescription] = React.useState(false);
  const [dealerIds, setDealerIds] = React.useState<string[]>([]);
  const [showErrorMessage, setShowErrorMessage] = React.useState("");
  const [openPriceRule, setOpenPriceRule] = React.useState(false);
  const [isResetRequest, setIsResetRequest] = React.useState(false);
  const [formData, setFormData] = React.useState({
    method: "+",
    amount: 0,
    applyOn: "$",
  });
  const [anchorAction, setAnchorAction] = React.useState<null | HTMLElement>(
    null
  );
  const [getProducts, productsDataResult] = useGetUsedProductsMutation();
  const [syncUsedProductMutation, syncUsedProductMutationResult] =
    useSyncUsedProductMutation();
  const [removeUsedProductMutation, removeUsedProductMutationResult] =
    useRemoveAggregateProductAsyncMutation();
  const [addPriceRule, addPriceRuleMutationResult] = useAddPriceRuleMutation();
  const handleClose = () => {
    setOpenDescription(false);
    setOpenPriceRule(false);
    setAnchorAction(null);
  };

  const handleSyncUsedProduct = (dmsProduct: any) => {
    syncUsedProductMutation({
      request: dmsProduct,
    }).then((res: any) => {
      if (res.data.status === 200) {
        let newProduct = res.data.entity;
        let shopifyProduct = {
          aggregateId: newProduct.id,
          handle: newProduct.shopifyProductLink,
          id: newProduct.shopifyProductId,
          onlinePrice: dmsProduct.price,
        };
        let updatedList = products.map((item) =>
          item.dmsProduct.mfrCode === newProduct.mfrCode &&
          item.dmsProduct.model === newProduct.model
            ? { ...item, shopifyProduct: shopifyProduct, isSynced: true }
            : item
        );
        setProducts(updatedList);
      }
    });
  };

  const handleRemoveProduct = (id: string) => {
    removeUsedProductMutation({ aggregateId: id }).then((res: any) => {
      if (res.data.status === 200) {
        fetchData();
      }
    });
  };

  const fetchData = () => {
    if (dealerIds.length > 0) {
      let request: DmsWhlegoodRequestDto = {
        dealerIds: dealerIds,
        search: paging.quickFilterValues.join(" "),
        pageNumber: paging.pageIndex,
        pageSize: paging.pageSize,
        searchModels: [],
        stockingOnly: true,
        wildCardSearch: true,
      };
      getProducts({ paging: request });
    }
  };

  React.useEffect(() => {
    if (Locations && Locations.length > 0) {
      let ids = Locations.map((item) => item.dealerId.toString());
      setDealerIds(ids);
    }
  }, [Locations]);

  React.useEffect(() => {
    fetchData();
  }, [paging, dealerIds]);

  React.useEffect(() => {
    if (productsDataResult.data && productsDataResult.isSuccess) {
      let totalRecords = productsDataResult.data.totalRecords;
      setProducts(productsDataResult.data.entityList);
      if (paging.pageIndex === 0 && totalRecords === paging.pageSize) {
        setProductsCount(totalRecords + 1);
      } else if (paging.pageIndex > 0 && totalRecords === paging.pageSize) {
        setProductsCount(productsCount + paging.pageSize);
      } else if (paging.pageIndex > 0 && totalRecords < paging.pageSize) {
        setProductsCount(productsCount + totalRecords);
      }
    }
  }, [productsDataResult]);

  React.useEffect(() => {
    setIsResetRequest(false);
    setFormData({
      amount: 0,
      method: "+",
      applyOn: "$",
    });
  }, [openPriceRule]);

  React.useEffect(() => {
    if (formData.applyOn === "$") {
      let price =
        formData.method === "+"
          ? Number(selectedProduct.price) + Number(formData.amount)
          : Number(selectedProduct.price) - Number(formData.amount);
      setNewPrice(price.toFixed(2));
    } else {
      let priceAdjust =
        Math.round(
          ((Number(formData.amount) * Number(selectedProduct.price)) / 100) *
            100
        ) / 100;
      let price =
        formData.method === "+"
          ? Number(selectedProduct.price) + priceAdjust
          : Number(selectedProduct.price) - priceAdjust;
      setNewPrice(price.toFixed(2));
    }
  }, [formData]);

  const handlePriceSubmit = (event: any) => {
    if (formData.method !== "reset") {
      if (
        !(formData.amount > 0) ||
        formData.applyOn === "" ||
        formData.method === ""
      ) {
        setShowErrorMessage("Please Fill Amount");
        return;
      }
    }
    setShowErrorMessage("");
    var items = [selectedProduct];
    addPriceRule({
      products: items,
      method: formData.method,
      amount: formData.amount,
      applyOn: formData.applyOn,
    }).then((res: any) => {
      if (res && res.data.status === 0) {
        handleClose();
        fetchData();
      } else {
        setShowErrorMessage("Sorry! We found an error.");
      }
    });
  };

  const handleResetPrice = () => {
    setShowErrorMessage("");
    var items = [selectedProduct];
    addPriceRule({
      products: items,
      method: "reset",
      amount: 0,
      applyOn: "",
    }).then((res: any) => {
      if (res && res.data.status === 0) {
        handleClose();
        fetchData();
      } else {
        setShowErrorMessage("Sorry! We found an error.");
      }
    });
  };

  const handleChange = (event: any) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };
  const columns: GridColDef[] = [
    {
      field: "mfgName",
      headerName: "Manufacturer",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.dmsProduct.mfgName + " - " + params.row.dmsProduct.mfrCode,
    },
    {
      field: "dmsProduct.model",
      headerName: "Model",
      flex: 1,
      valueGetter: (params: GridValueGetterParams) =>
        params.row.dmsProduct.model,
    },
    {
      field: "dmsProduct.productLine",
      headerName: "Category",
      flex: 1,
      valueGetter: (params: GridValueGetterParams) =>
        params.row.dmsProduct.productLine,
    },
    {
      field: "dmsProduct.description",
      headerName: "Description",
      flex: 1,
      valueGetter: (params: GridValueGetterParams) =>
        params.row.dmsProduct.description,
    },
    {
      field: "dmsProduct.price",
      headerName: "Price ($)",
      headerAlign: "right",
      flex: 1,
      type: "number",
      filterable: false,
      align: "right",
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.dmsProduct.price.toFixed(2),
    },
    {
      field: "shopifyProduct.onlinePrice",
      headerName: "Online Price ($)",
      headerAlign: "right",
      flex: 1,
      filterable: false,
      align: "right",
      renderCell: (params: GridRenderCellParams) => {
        return params.row?.isSynced !== true ? (
          "N/A"
        ) : params.row?.shopifyProduct?.NotExistsOnShopify !== true &&
          params.row.shopifyProduct?.onlinePrice !== null ? (
          <Button
            onClick={() => {
              setSelectedProduct({
                shopifyProductId: params.row.shopifyProduct.id,
                productAggId: params.row.shopifyProduct.aggregateId,
                price: params.row.shopifyProduct.onlinePrice,
              });
              setNewPrice(params.row.shopifyProduct.onlinePrice.toFixed(2));
              setOpenPriceRule(true);
            }}
          >
            {params.row.shopifyProduct.onlinePrice.toFixed(2)}
          </Button>
        ) : (
          <Tooltip title="The product does not exist on Shopify; you can delete it from here.">
            <WarningIcon fontSize="small" color="error" />
          </Tooltip>
        );
      },
    },
    {
      field: "dmsProduct.cost",
      headerName: "Cost ($)",
      headerAlign: "right",
      flex: 1,
      align: "right",
      type: "number",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.dmsProduct.cost.toFixed(2),
    },
    {
      field: "dmsProduct.stockItem",
      headerName: "Stocking Type",
      headerAlign: "center",
      flex: 1,
      align: "center",
      renderCell: (params: GridRenderCellParams) => {
        return params?.row?.dmsProduct.stockItem ? (
          <Chip label="Stocking" color="success" size="small" />
        ) : (
          <Chip label="Non Stocking" color="warning" size="small" />
        );
      },
    },
    {
      field: "dmsProduct.locationCount",
      headerName: "In Store",
      align: "right",
      headerAlign: "right",
      type: "number",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<any>) => {
        if (params.row?.dmsProduct.locationCount) {
          return params.row?.dmsProduct.locationCount?.reduce(
            (partial: number, value: any) => partial + value.count,
            0
          );
        } else {
          return 0;
        }
      },
    },
    {
      field: "Sync",
      headerName: "Sync As Used",
      type: "actions",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return params?.row?.isSynced === true ? (
          <Button
            disabled={removeUsedProductMutationResult.isLoading}
            color="error"
            variant="contained"
            size="small"
            sx={{ fontSize: "0.7rem" }}
            onClick={() => {
              handleRemoveProduct(params.row.shopifyProduct.aggregateId);
            }}
          >
            Delete
          </Button>
        ) : (
          <Button
            disabled={syncUsedProductMutationResult.isLoading}
            color="warning"
            variant="contained"
            size="small"
            sx={{ fontSize: "0.7rem" }}
            onClick={() => {
              handleSyncUsedProduct(params.row.dmsProduct);
            }}
          >
            Sync
          </Button>
        );
      },
    },
    {
      field: "actions",
      headerName: "View / Edit",
      type: "actions",
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            <Chip
              label="Action"
              color="info"
              size="small"
              disabled={params.row.isSynced !== true}
              onClick={(event) => {
                setSelectedRowData(params.row);
                setAnchorAction(event.currentTarget);
              }}
            />
            <Menu
              anchorEl={anchorAction}
              open={Boolean(anchorAction)}
              onClose={handleClose}
            >
              <MenuItem
                onClick={() => {
                  window.open(
                    `${dmsSetup?.shopifyUrl}/products/${selectedRowData?.shopifyProduct?.handle}`,
                    "_blank"
                  );
                  setAnchorAction(null);
                }}
              >
                <ListItemIcon>
                  <VisibilityIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>View</ListItemText>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setOpenDescription(true);
                  setAnchorAction(null);
                }}
              >
                <ListItemIcon>
                  <EditIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Edit</ListItemText>
              </MenuItem>
            </Menu>
          </>
        );
      },
    },
  ];
  return (
    <>
      <Container maxWidth={false}>
        <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
          Used Products
        </Typography>
        <ServerAppGrid
          gridId={AppGridId.Used_Products}
          data={
            products?.length > 0
              ? products.map((n, i) => ({ id: i, ...n }))
              : []
          }
          columns={GetAppGridColumns(
            columns,
            gridSetting?.columnVisibilityModel
          )}
          isLoading={
            productsDataResult.isLoading ||
            syncUsedProductMutationResult.isLoading ||
            removeUsedProductMutationResult.isLoading
          }
          paging={paging}
          setPaging={setPaging}
          totalRecords={productsCount}
          height={"75vh"}
          hidePaginator={true}
          hideCheckBoxes={true}
          hidePaginationText={true}
          hideColumnFilter={true}
        />

        <Dialog open={openDescription} fullWidth={true} maxWidth="lg">
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: 0,
              paddingLeft: "16px",
              paddingRight: "16px",
            }}
          >
            <h4>Shopify Product Details</h4>
            <IconButton
              onClick={() => {
                handleClose();
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ width: "100%" }}>
            <ShopifyProductDetails
              shopifyProductId={selectedRowData?.shopifyProduct?.id}
              handleUpdateMatchingType={() => {}}
            ></ShopifyProductDetails>
          </DialogContent>
        </Dialog>
      </Container>
      <Dialog open={openPriceRule} onClose={handleClose} fullWidth>
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography sx={{ fontWeight: "bold" }}>Price Rule</Typography>
          <Tooltip title="After resetting, DMS price will be applied on this product">
            <Button
              disabled={addPriceRuleMutationResult.isLoading}
              variant="contained"
              color="error"
              size="small"
              onClick={() => {
                setIsResetRequest(true);
                handleResetPrice();
              }}
            >
              {addPriceRuleMutationResult.isLoading && isResetRequest ? (
                <CircularProgress size="1.2rem" color="inherit" />
              ) : (
                "Reset Price"
              )}
            </Button>
          </Tooltip>
        </DialogTitle>
        <DialogContent>
          <Grid mt={2} container justifyContent="space-between">
            <Grid item md={3}>
              <Typography
                sx={{ fontWeight: "bold", pt: 1 }}
                variant="subtitle2"
                gutterBottom
              >
                Method
              </Typography>
            </Grid>
            <Grid item md={5}>
              <Typography
                sx={{ fontWeight: "bold", pt: 1 }}
                variant="subtitle2"
                gutterBottom
              >
                Amount
              </Typography>
            </Grid>
            <Grid pl={1} item md={4}>
              <Typography
                sx={{ fontWeight: "bold", pt: 1 }}
                variant="subtitle2"
                gutterBottom
              >
                ApplyOn
              </Typography>
            </Grid>
          </Grid>
          <Grid mt={0} container justifyContent="space-between">
            <Grid item md={3}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="method"
                value={formData.method}
                onChange={handleChange}
                sx={{ display: "flex", flexDirection: "column" }}
              >
                <FormControlLabel
                  value={"+"}
                  control={<Radio />}
                  label={<Typography fontSize="0.8rem">Increase</Typography>}
                />
                <FormControlLabel
                  value={"-"}
                  control={<Radio />}
                  label={<Typography fontSize="0.8rem">Decrease</Typography>}
                />
              </RadioGroup>
            </Grid>
            <Grid item md={5} mt={2}>
              <TextField
                variant="standard"
                name="amount"
                fullWidth
                size="small"
                type="number"
                required
                value={formData.amount}
                onChange={handleChange}
              />
            </Grid>
            <Grid pl={1} item md={4}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="applyOn"
                value={formData.applyOn}
                onChange={handleChange}
                sx={{ display: "flex", flexDirection: "column" }}
              >
                <FormControlLabel
                  value={"$"}
                  control={<Radio />}
                  label={<Typography fontSize="0.8rem">Dollars $</Typography>}
                />
                <FormControlLabel
                  value={"%"}
                  control={<Radio />}
                  label={<Typography fontSize="0.8rem">Percent %</Typography>}
                />
              </RadioGroup>
            </Grid>
          </Grid>
          <Typography sx={{ mt: 1 }}>
            New Price after applying rule= {newPrice}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Typography mr="12%" color="red">
            {showErrorMessage}
          </Typography>
          <Button
            variant="outlined"
            size="small"
            autoFocus
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            size="small"
            disabled={addPriceRuleMutationResult.isLoading}
            onClick={handlePriceSubmit}
          >
            {addPriceRuleMutationResult.isLoading && !isResetRequest ? (
              <CircularProgress size="1.2rem" color="inherit" />
            ) : (
              "Apply Rule"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UsedProducts;
